module.exports = __webpack_public_path__ + "img/avatar4.15fe152f.png";